const entrada = () => {
    return (  
        <>
            <main className="contenedor">
                <h2 className="heading">Cómo elegir tu primer guitarra</h2>

                <article className="entrada">
                    <img className="entrada__imagen" src="img/blog_1.jpg" alt="imagen blog"/>

                    <div className="entrada__contenido">
                        <h3 className="entrada__titulo">¿Como elegir tu primer guitarra?</h3>
                        <p className="entrada__fecha">20 de Enero de 2022</p>

                        <p className="entrada__texto">Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio delectus laborum, quas assumenda, dolorem placeat quo, aliquam labore incidunt alias molestiae maxime quaerat distinctio numquam quam voluptatum. Beatae, molestiae vitae?</p>
                        <p className="entrada__texto">Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio delectus laborum, quas assumenda, dolorem placeat quo, aliquam labore incidunt alias molestiae maxime quaerat distinctio numquam quam voluptatum. Beatae, molestiae vitae?</p>
                        <p className="entrada__texto">Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio delectus laborum, quas assumenda, dolorem placeat quo, aliquam labore incidunt alias molestiae maxime quaerat distinctio numquam quam voluptatum. Beatae, molestiae vitae?</p>
                        <p className="entrada__texto">Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio delectus laborum, quas assumenda, dolorem placeat quo, aliquam labore incidunt alias molestiae maxime quaerat distinctio numquam quam voluptatum. Beatae, molestiae vitae?</p>

                    </div>
                </article>
            </main>
 
        </>
    );
}
 
export default entrada;